module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_04_beach-photo-eeacd99a8ab73a709a02a7de24792da4.jpg";